import createIcon from '../../createIcon';

/**
 * @component @name EdgesensorLow
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiA3SDRWMTRIMlY3Wk0yMCAxMEgyMlYxN0gyMFYxMFpNMTYgMi4wMUw4IDJDNi45IDIgNiAyLjkgNiA0VjIwQzYgMjEuMSA2LjkgMjIgOCAyMkgxNkMxNy4xIDIyIDE4IDIxLjEgMTggMjBWNEMxOCAyLjkgMTcuMSAyLjAxIDE2IDIuMDFaTTE2IDE3SDhWN0gxNlYxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EdgesensorLow = createIcon('EdgesensorLow', [
  [
    'path',
    {
      d: 'M2 7H4V14H2V7ZM20 10H22V17H20V10ZM16 2.01L8 2C6.9 2 6 2.9 6 4V20C6 21.1 6.9 22 8 22H16C17.1 22 18 21.1 18 20V4C18 2.9 17.1 2.01 16 2.01ZM16 17H8V7H16V17Z',
      key: 'fe9vgd',
    },
  ],
]);

export default EdgesensorLow;
